import request from '@services/request';

export const getCorresponsalCorrespondent = () => {
  return request
    .get('/api/v1/corresponsal/correspondent')
    .then((response) => {
      const rta = response.data.data;
      const data = rta.map((item) => {
        return {
          id: item.id,
          label: item.business_name,
          corrTypeId: item.correspondent_types_id,
          groupName: 'correspondent',
        };
      });
      return data;
    });
};

export const getCorresponsalSubsidiaries = (correspondentId) => {
  return request
    .get(`/api/v1/corresponsal/subsidiaries/${correspondentId}`)
    .then((response) => {
      const rta = response.data.data;
      const data = rta.map((item) => {
        return {
          id: item.id,
          label: item.name,
          groupName: 'subsidiary',
        };
      });
      return data;
    });
};

export const getCorresponsalRoles = (correspondentTypeId) => {
  return request
    .get(`/api/v1/corresponsal/roles/${correspondentTypeId}`)
    .then((response) => {
      const rta = response.data.data;
      const data = rta.map((item) => {
        return {
          id: item.role_id,
          label: item.name,
          groupName: 'role',
        };
      });
      return data;
    });
};

export const createUser = async (user) => {
  const result = await request.post('/api/v1/corresponsal/users/create', user);
  const { data } = result;
  return data;
};

export const updateUser = async (profileId, user) => {
  const result = await request.put(`/api/v1/corresponsal/users/${profileId}`, user);
  const { data } = result;
  return data;
};

export const deleteUser = async (profileId) => {
  const result = await request.methodDelete(`/api/v1/corresponsal/users/${profileId}`);
  const { data } = result;
  return data;
};

export const validateMailAnotherCorrespondent = async (dataValid) => {
  const result = await request.post('/api/v1/corresponsal/users/validate-email', dataValid);
  const { data } = result;
  return data;
};

export const getUserProfile = async (user, tenantId = null) => {
  let url = `/api/v1/corresponsal/users/profile/${user}`;
  const params = {};
  if (tenantId) {
    params.tenantId = tenantId;
  }
  const result = await request.get(url, params);
  const { data } = result;
  return data;
};
